import React from 'react';

const MenuItem = ({ item, showPrice = true, priceColor = 'text-deep-violet' }) => {
  return (
    <div className="glass-card menu-card p-6 relative">
      {item.isSignature && (
        <div className="absolute top-4 right-4 bg-neon-pink text-bg-dark px-3 py-1 rounded-full text-xs font-bold">
          SIGNATURE
        </div>
      )}
      <h4 className="text-xl font-bold text-neon-pink mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
        {item.name}
      </h4>
      {item.description && (
        <p className="text-white/70 text-sm mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {item.description}
        </p>
      )}
      {item.winery && (
        <p className="text-white/60 text-xs mb-3 uppercase tracking-wider" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {item.winery}
        </p>
      )}
      {showPrice && item.price && (
        <p className={`${priceColor} text-lg font-bold`} style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {item.price}
        </p>
      )}
      {item.size && (
        <p className="text-white/60 text-xs mt-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {item.size}
        </p>
      )}
    </div>
  );
};

export default MenuItem;
